import { useGetSelectionFormData } from "@/api/cms";
import {
  useGetSectionById,
  useGetSectionMetadata,
  useGetSectionSelections,
} from "@/api/section";
import { GridDisplay } from "@/components/cms/selection/GridDisplay";
import { Button } from "@/components/ui/button";
import { getMainLanguage } from "@/i18n";
import CMSLayout from "@/layout/CMSLayout";
import { LayoutNonNullable } from "@/lib/cms/section-types";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";

const Section = () => {
  const { id } = useParams();
  const { data: sectionData } = useGetSectionById(id);
  const { data: selectionPageData } = useGetSelectionFormData();
  const { data: selectedImages } = useGetSectionSelections(id);
  const { data: sectionMetadata } = useGetSectionMetadata(id);
  const { t } = useTranslation();

  return (
    <CMSLayout
      hideSubmitButton
      breadcrumbs={[
        {
          label:
            selectionPageData?.[getMainLanguage()]?.pageName ??
            t("cmsTabSelection"),
          to: "/cms/selection",
        },
        {
          label: sectionData?.content[getMainLanguage()]?.title ?? "",
        },
      ]}
      formIds={["section"]}
      pageName={sectionData?.content[getMainLanguage()]?.title ?? ""}
    >
      <form id="section" className="flex flex-col gap-6 w-full">
        <div className="flex flex-row justify-between items-center">
          <p>{t("cms.section.artworks")}</p>
          <div className="flex flex-row gap-2">
            <Link to={`/cms/selection/edit-section/${id}`}>
              <Button variant={"outline"}>
                {t("cms.section.editSection.button")}
              </Button>
            </Link>
            <Link to={`artworks`}>
              <Button variant={"outline"}>
                {t("cms.section.manageArtworks.button")}
              </Button>
            </Link>
          </div>
        </div>
        {selectedImages && sectionMetadata && (
          <GridDisplay
            displayable={{ dType: "selection", data: selectedImages }}
            layout={sectionMetadata.layout as LayoutNonNullable}
            visibility={sectionMetadata}
          />
        )}
      </form>
    </CMSLayout>
  );
};

export default Section;
